import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
 
} from '@mui/material'

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import dayjs, { Dayjs } from 'dayjs';
import * as React from 'react';


const ShopTimingEditCard = (
    {item,
                openFrom1,
                   openTo1,
                   brkFrom1,
                   brkTo1}
) => {


    const listStyles = {
        color: '#000',
        fontSize: '24px',
        fontFamily: 'sans-serif',
 
        padding: '0px',
       margin: '0px'
      }

    


    return(
        <>
        <hr/>
            <List className='timingInfoCard'>

          
                

                
                <div>   

                { item!==null ?
                    <div className='mt-3 content'>

               
                       
                   
                                            
                           <div>
              <Divider variant='inset' component="li"/>
             
              <ListItem>
                    
                    <ListItemAvatar>
                        <Avatar><AccessTimeIcon/></Avatar>
                        </ListItemAvatar>
                        <ListItemText style={listStyles} primary="Timings" />
                
                    
                  </ListItem>
                

               
                
                  
                
                    <ListItem>
                    
                    <ListItemText style={listStyles} primary="Open" />
                   
                    </ListItem>
                    <ListItem>
                <ListItemText style={listStyles} primary={openFrom1(item,item.openFrom)} />
                <ListItemText style={listStyles} primary={openTo1(item,item.openTo)} />
                </ListItem>


               
                    <ListItem>
                    
                    <ListItemText style={listStyles} primary="Break" />
                   
                    </ListItem>
                    <ListItem>
                <ListItemText style={listStyles} primary={brkFrom1(item,item.brkFrom)} />
                <ListItemText style={listStyles} primary={brkTo1(item,item.brkTo)} />
                </ListItem>


                <ListItem>
                <ListItemText style={listStyles} primary={item.remark} />
                </ListItem>
                
              
                <ListItem>
                
                <ListItemText style={listStyles} primary="weekStatus" secondary={item.weekStatus} />
                <ListItemText style={listStyles} primary="timeStatus" secondary={item.timeStatus} />
                <ListItemText style={listStyles} primary="brkStatus" secondary={item.brkStatus} />
                </ListItem>
               
                
                            </div>                 
                               
                     
                                        
                                            
                        
                        
                        
                   
                        
                        
                        

                            
              
                
                    </div>
                    :null
}                      
</div> 

               
            </List>
           

        </>
    )
}

export default ShopTimingEditCard;